import React from "react";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { http } from "@/lib/api";
import { CONTACT } from "@/constants/testIds";
import { ASSOC } from "@/lib/data";
import { Mail, Phone, MapPin, Instagram } from "lucide-react";

const POLE_OPTIONS = [
  "Afrolat'Studio",
  "Heel's la Compagnie",
  "Heel'Events Solidarité",
  "L'Entrée des Artistes",
  "Autre",
];

export default function Contact() {
  const [form, setForm] = React.useState({
    first_name: "", last_name: "", email: "", phone: "",
    subject: "", pole: "Afrolat'Studio", message: "",
  });
  const [loading, setLoading] = React.useState(false);
  const [done, setDone] = React.useState(false);
  const change = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await http.post("/contact", form);
      setDone(true);
      toast.success("Message envoyé ! Nous vous répondons rapidement.");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erreur lors de l'envoi.");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-16 sm:py-24 grid grid-cols-1 lg:grid-cols-2 gap-14">
      <div>
        <p className="he-overline text-neutral-500">Nous parler</p>
        <h1 className="font-heading text-5xl sm:text-6xl font-black tracking-tighter mt-3">Contact</h1>
        <p className="mt-4 text-neutral-600 font-body">Une question, une envie de danser, un projet ? Écrivez-nous.</p>

        <div className="mt-10 space-y-4 font-body">
          <div className="flex items-start gap-3"><MapPin className="w-5 h-5 text-[var(--he-red)] mt-0.5" /><div><div className="font-bold">Heel’Events</div><div className="text-sm text-neutral-600">{ASSOC.address}</div></div></div>
          <div className="flex items-center gap-3"><Phone className="w-5 h-5 text-[var(--he-red)]" /><a href={`tel:${ASSOC.phone.replace(/\s/g,'')}`} className="hover:text-[var(--he-red)]">{ASSOC.phone}</a></div>
          {ASSOC.emails.map(e => <div key={e} className="flex items-center gap-3"><Mail className="w-5 h-5 text-[var(--he-red)]" /><a href={`mailto:${e}`} className="hover:text-[var(--he-red)]">{e}</a></div>)}
          <div className="flex items-center gap-3"><Instagram className="w-5 h-5 text-[var(--he-red)]" /><a href={ASSOC.instagramUrl} target="_blank" rel="noreferrer" className="hover:text-[var(--he-red)]">{ASSOC.instagram}</a></div>
        </div>
      </div>

      {done ? (
        <div className="p-8 border border-black/10 rounded-2xl bg-neutral-50">
          <h2 className="font-heading text-2xl font-bold">Merci pour votre message !</h2>
          <p className="mt-3 text-sm text-neutral-600 font-body">Nous revenons vers vous rapidement à l’adresse indiquée.</p>
          <Link to="/" className="mt-6 inline-block btn-red rounded-full px-6 py-3 text-sm">Retour à l’accueil</Link>
        </div>
      ) : (
        <form data-testid={CONTACT.form} onSubmit={submit} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Field label="Prénom *"><input required data-testid={CONTACT.firstName} value={form.first_name} onChange={change("first_name")} className={inp} /></Field>
          <Field label="Nom *"><input required data-testid={CONTACT.lastName} value={form.last_name} onChange={change("last_name")} className={inp} /></Field>
          <Field label="Email *"><input required type="email" data-testid={CONTACT.email} value={form.email} onChange={change("email")} className={inp} /></Field>
          <Field label="Téléphone"><input data-testid={CONTACT.phone} value={form.phone} onChange={change("phone")} className={inp} /></Field>
          <Field label="Objet *" className="sm:col-span-2"><input required data-testid={CONTACT.subject} value={form.subject} onChange={change("subject")} className={inp} /></Field>
          <Field label="Pôle concerné *" className="sm:col-span-2">
            <select required data-testid={CONTACT.pole} value={form.pole} onChange={change("pole")} className={inp}>
              {POLE_OPTIONS.map(p => <option key={p}>{p}</option>)}
            </select>
          </Field>
          <Field label="Message *" className="sm:col-span-2">
            <textarea required rows={5} data-testid={CONTACT.message} value={form.message} onChange={change("message")} className={inp + " resize-none"} />
          </Field>
          <div className="sm:col-span-2">
            <button data-testid={CONTACT.submit} disabled={loading} className="btn-red rounded-full px-8 py-3 text-sm disabled:opacity-60">
              {loading ? "Envoi..." : "Envoyer"}
            </button>
          </div>
        </form>
      )}
    </div>
  );
}

const inp = "border border-black/15 rounded-lg px-3 py-2.5 text-sm w-full bg-white focus:outline-none focus:ring-2 focus:ring-[var(--he-red)]/40";
function Field({ label, children, className = "" }) {
  return (
    <label className={`flex flex-col ${className}`}>
      <span className="he-overline text-neutral-500 mb-1.5">{label}</span>
      {children}
    </label>
  );
}
